<template>
  <div>
    <v-layout  row wrap class="mb-5" v-if="currentCompany.id== DEFINES.FIREPLACE_AD_COMPANY_ID">
      <v-flex>
        <v-card flat color="background">
            <v-layout row wrap>

              <v-flex >
                 <!-- Screener Film detail -->
                <v-card-text class="px-0 pt-0">
                  <ForgivenessOverview v-if="screener.id== DEFINES.FIREPLACE_AD_SCREENER_ID" :screener="screener" @onBuyTicket="initiateEnrollment"  @onWatch="goToWatchPage"></ForgivenessOverview>
                  <Screener v-else :screener="screener"></Screener>
                </v-card-text>
                <!-- <v-divider class="primary divider-custom-height"></v-divider> -->

                <v-card-text
                  id="pricing-handler"
                  class="px-0 pt-0 grey lighten-4"
                  v-if="!screener.is_vod_event && !isScreeningArchive && isScreeningPaid(screener) && !isConsumerPurchased(screener.id)"
                >
                  <h3 class="pa-3 greyDarken3--text">
                    {{ $t("screener.monetization.select_pricing_plan") }}
                  </h3>
                  <PricingHandler
                    :screener="screener"
                    @onSetPricingPlan="setPricingPlan"
                  ></PricingHandler>
                </v-card-text>
                <v-card-text class="text-xs-center">
                  <!-- Button Decider -->
                  <!-- <ScreenerButton
                    :buttonProps="buttonProps"
                    :screener="screener"
                    @onBuyTicket="initiateEnrollment"
                    @onParticipate="initiateEnrollment"
                    @onWatch="goToWatchPage"
                  /> -->
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else-if="screener" row wrap class="mb-5" >
      <v-flex  xs12>
        <v-container :ma-0="!isEmbedMode || !isFullScreenMode">
          <v-card flat color="background">
            <!-- Screener Header -->
            <ScreenerHeader
              :screener="screener"
              :showBeInRegister="false"
              @onBuyTicket="initiateEnrollment"
              @onParticipate="initiateEnrollment"
              @onWatch="goToWatchPage"
              @onBuyVenueTicket="initiateEnrollment"
            ></ScreenerHeader>
            <!-- Screener Film detail -->
            <v-card-text class="px-0 pt-0">
              <Screener :screener="screener"></Screener>
            </v-card-text>
            <v-card-text class="text-xs-center">
              <!-- Button Decider -->
              <ScreenerButton
                :buttonProps="buttonProps"
                :screener="screener"
                @onBuyTicket="initiateEnrollment"
                @onParticipate="initiateEnrollment"
                @onWatch="goToWatchPage"
                @onBuyVenueTicket="initiateEnrollment"
              />
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
    <Enrollment
      :dialog.sync="dialog"
      :screener.sync="screener"
      :pricing="pricingPlan"
      @onPurchased="goToWatchPage"
    ></Enrollment>
  </div>
</template>


<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";
import Screener from "@/components/screener/Screener";
import ScreenerHeader from "@/components/screener/Header";
import i18n from "@/i18n";
import rules from "@/validation";
import DEFINES from "@/defines";
import { getAddToCalLink, isDatePast } from "@/helpers";
import ScreenerButton from "@/components/screener/ScreenerButton";
import Enrollment from "@/components/company/Enrollment";
import PricingHandler from "@/components/screener/PricingHandler";
import ForgivenessOverview from "./ForgivenessOverview"

export default {
  name: "ScreenerOverview",
  metaInfo() {
    if (this.screener) {
      return {
        title: this.screener.title
      };
    }
  },
  async beforeRouteEnter(to, from, next) {
    await next(vm => {
      if (to.params.screener_id) {
        vm.getScreenerFromApi();
      }
    });
  },
  data() {
    return {
      rules,
      verification: false,
      formattedNumber: null,
      translations: {
        phoneNumberLabel: i18n.t("screening.register.lable.phone")
      },
      Optionaltranslations: {
        phoneNumberLabel: i18n.t("screening.register.lable.optional")
      },
      customer: {
        name: "",
        phone: "",
        email: "",
        screener_id: null
      },
      screener: null,
      dialog: false,
      buttonProps: {
        large: true
      },
      pricingPlan: null
    };
  },
  components: {
    Screener,
    ScreenerHeader,
    ScreenerButton,
    Enrollment,
    PricingHandler,
    ForgivenessOverview
  },
  computed: {
    ...mapState({
      currentCompany: state => state.company.company,
      isFullScreenMode: state => state.app.isFullScreenMode
    }),
    ...mapGetters("screening", {
      isScreeningPaid: "isScreeningPaid"
    }),
    ...mapGetters("consumer", {
      isConsumerPurchased: "isPurchased",
      vodEventStartTime: "getVodEventStartTime",
      vodEventEndTime: "getVodEventEndTime"
    }),
    isScreeningArchive: function(){
      return isDatePast(this.screener.registration_ends_at);
    },
    isEmbedMode() {
      return this.$route.query.allowEmbed ? this.$route.query.allowEmbed === 'true': false
    },
  },
  methods: {
    async getScreenerFromApi() {
      try {
        let response = await this.$store.dispatch("screening/get", {
          id: this.$route.params.screener_id
        });
        this.screener = response.screener;
      } catch (error) {
        await this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
        if(!(this.$route.query && this.$route.query.allowEmbed)){
          this.goToCompanyDashboard();
        }
      }
    },
    goToCompanyDashboard() {
      this.$router.push({
        name: "company.dashboard"
      });
    },

    initiateEnrollment() {
     this.dialog = true;
    },
    goToWatchPage(screener) {
       /*
        In case of Embed, there would be a query param which we need to carry forward
        in order to hide some of the page section
       */
      this.$router.push({
        name: "screeners.watch",
        params: {
          screener_id: screener.id
        },
        query: this.$route.query
      });
    },
    setPricingPlan(plan) {
      this.pricingPlan = plan;
    }
  }
};
</script>

<style></style>
